import { useMutation } from "@tanstack/react-query";
import axios from "../api/axios";
import Cookies from "universal-cookie";
import { TOKEN_NAME, COMPANY_ID, PRODUCT_SLUG } from "../config";

const cookies = new Cookies();

function useDownloadGetFile({ url, filename, onSuccess, onError }) {
  const download = useMutation((queryParams = {}) => downloadFile(queryParams), {
    onSuccess: (data) => {
      const href = URL.createObjectURL(new Blob([data.data]));
      let a = document.createElement("a");
      a.href = href;
      a.download = filename || "download";
      a.click();
      window.URL.revokeObjectURL(href);
      onSuccess?.(data);
    },
    onError: (err) => {
      onError?.(err);
    },
  });

  const downloadFile = async (queryParams = {}) => {
    const token = cookies.get(TOKEN_NAME);
    const company_id = cookies.get(COMPANY_ID);

    const params = {
      company_id,
      product_slug: PRODUCT_SLUG,
      ...queryParams,
    };

    const response = await axios({
      method: "GET",
      url: `/${url}`,
      params,
      responseType: "blob",
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });

    return response;
  };

  return { download, isLoading: download.isLoading };
}

export default useDownloadGetFile;
